import { useGetProfileQuery } from "store/slices/profile-api";

export function useVerification() {
    const { data: userProfileData, isLoading } = useGetProfileQuery();
    const isVerified = userProfileData?.verificationStatus == 'Verified';
    const isVerificationPending = userProfileData?.verificationStatus == 'Pending';
    const isVerificationInProgress = userProfileData?.verificationStatus == 'InProgress';

    return {
        isLoading,
        isVerified,
        isVerificationPending,
        isVerificationInProgress,
    };
}
